var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8077 15.6328C19.8077 15.828 19.7687 16.0232 19.6906 16.2028C19.6151 16.3827 19.5065 16.5469 19.3705 16.6869C19.2292 16.8204 19.0652 16.9289 18.8864 17.007C18.7031 17.0816 18.5066 17.1188 18.3087 17.1163C17.425 17.1013 16.5425 17.1851 15.6775 17.3661C14.6524 17.487 13.6649 17.8251 12.7808 18.3577V6.71647C13.6327 6.31047 14.5454 6.04657 15.4823 5.9357C16.4358 5.74642 17.4069 5.66004 18.3789 5.67805C18.7661 5.69954 19.1299 5.87025 19.3939 6.15432C19.6516 6.42915 19.7945 6.7922 19.7921 7.16931L19.8077 15.6328ZM11.2193 6.71647V18.3577C10.3498 17.8302 9.37866 17.4923 8.36951 17.3661C7.48825 17.1879 6.5905 17.1041 5.69148 17.1163C5.49353 17.1188 5.29708 17.0816 5.11371 17.007C4.93536 16.9285 4.77167 16.8202 4.62964 16.6869C4.49041 16.5495 4.38139 16.3847 4.30952 16.2028C4.23115 16.023 4.19126 15.8289 4.19241 15.6328V7.12247C4.19364 6.74609 4.33789 6.38424 4.59594 6.11025C4.85399 5.83625 5.20654 5.67059 5.58217 5.64682C6.57507 5.62172 7.56765 5.70814 8.54128 5.90447C9.47326 6.02264 10.3786 6.29715 11.2193 6.71647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBook);
export default __webpack_public_path__ + "static/media/ic_book.f9ae4aa93c31f40d2e27d78b8d5bda5e.svg";
export { ForwardRef as ReactComponent };